import { createStore } from 'satcheljs';
import { GetStartedTaskId } from './schema/GetStartedTaskId';
import { GetStartedTaskStatus } from './schema/GetStartedTaskStatus';

export interface GetStartedStoreObject {
    identity: GetStartedTaskId;
    status: GetStartedTaskStatus;
    clicked: boolean;
}

export interface GetStartedStore {
    tasks: { [K in keyof typeof GetStartedTaskId]: GetStartedStoreObject };
}

export let getStore = createStore<GetStartedStore>('getStartedStore', {
    tasks: null,
});
